import {
    CTALink,
    CTAMissing,
    CTAToken,
    TOKEN_TYPE,
} from "@hermes/api-model-editorial";

export function isCTALink(token: CTAToken | undefined): token is CTALink {
    return (
        token !== undefined &&
        (token.tokenType === TOKEN_TYPE.ctaStory ||
            token.tokenType === TOKEN_TYPE.ctaCategory)
    );
}

export function isCTALinkOrMissing(
    token: CTAToken | undefined,
): token is CTALink | CTAMissing {
    return (
        token !== undefined &&
        (token.tokenType === TOKEN_TYPE.ctaStory ||
            token.tokenType === TOKEN_TYPE.ctaCategory ||
            token.tokenType === TOKEN_TYPE.ctaMissing)
    );
}
